var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.value)?_c('Loading'):_c('CruResource',{attrs:{"resource":_vm.value,"mode":_vm.mode,"errors":_vm.errors},on:{"finish":_vm.save}},[_c('LabeledInput',{attrs:{"label":_vm.t('managementNode.customName'),"mode":_vm.mode},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }